import React from 'react';
import { translated } from '../../utils/TranslationUtil';

export const SendIcon: React.FC<{}> = () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 20' height='100%' width='100%' fill='none'>
        <title>{translated('Accessibility.SvgTitle.sendIcon')}</title>
        <path
            id='^ Name above ^'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M4 11H16.2L10.6 5.4L12 4L20 12L12 20L10.6 18.6L16.2 13H4V11Z'
        />
    </svg>
);